@if (loading()) {
    <app-loader [isLoading]="loading()"/>
}
<mat-dialog-content>
    <h4 mat-card-title>Кассовый аппарат</h4>
    <form class="flex-column" [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field>
            <mat-label>ИН Кассы</mat-label>
            <input matInput formControlName="paymentDeviceSn">
            <mat-error>{{ getErrorMessage('paymentDeviceSn', form) }}</mat-error>
        </mat-form-field>

        <div class="flex a-center justify-between mrt-1">
            <button mat-stroked-button color="accent" type="button" (click)="onCancel()">Назад</button>
            <button mat-flat-button color="primary" [disabled]="form.invalid">Сохранить</button>
        </div>
    </form>
</mat-dialog-content>
